import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/shared/organisms/cerrix-linked-item-table/i18n/scope";
import { CerrixIconButtonComponent } from "../../../atoms/cerrix-icon-button/cerrix-icon-button.component";

@Component({
    selector: "app-linked-item-table-row-actions",
    imports: [TranslatePipe, CerrixIconButtonComponent],
    viewProviders: [provideTranslationScope(scope)],
    styleUrl: "./linked-item-table-row-actions.scss",
    templateUrl: "./linked-item-table-row-actions.component.html",
})
export class LinkedItemTableRowActionsComponent {
    @Input({ required: true }) itemLabel: string | number;
    @Input() disabled = false;
    @Input() canUnlink = true;
    @Output() open = new EventEmitter<void>();
    @Output() unlink = new EventEmitter<void>();
}
